import { Injectable } from '@angular/core';
import { PartnerInformationApi } from '.';
/**
 * This class is essentially a wrapper around PartnerInformationApi,
 * and has been left as is when porting from SPA to avoid directly calling the api class
 * from components
 */
@Injectable({
    providedIn: 'root'
})
export class PartnerInformationService {
    constructor(private partnerApi: PartnerInformationApi) {}

    getPartnerInformationForCurrentCompany() {
        return this.partnerApi.getPartnerInformation();
    }

    getPartnerInformationForCurrentCompanyV5() {
        return this.partnerApi.getPartnerInformationV5();
    }
}
